import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper/index";
// import GetAllFormFields from '../../../components/_utils/formUtils'
import moment from "moment";
import { Button, Card, Drawer, Form, Icon, Select, Table, Tabs, Steps } from "antd";
import _ from "lodash";
import S from "string";
import StudentHeader from "../../../components/studentHeader/index";

import Request from "../../../request";
import { connect } from "react-redux";
import StudentInfo from "../../../components/StudentInfo";
import renderHTML from "react-render-html";
import { TableComp } from "sz-react-utils";

const Option = Select.Option;

const TabPane = Tabs.TabPane;
const { Step } = Steps
const config = {
  rules: [{ type: "object", required: true, message: "Please select time!" }],
};

// following variables needed for update country
let docLoaded = null;
let countryId = null;

@Form.create()
class Activity extends PureComponent {
  state = {
    studentId: "",
    count: 0,
    activityArr: [],
    data: []
  };
  callback = (key) => {
    let inputTypes = this.state.inputTypes;

    if (countryId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
      inputTypes[key - 1].opened = true;
      let tempObj = {};
      _.each(inputTypes[key - 1].fields, (v, k) => {
        tempObj[v.key] = docLoaded[v.key];
      });

      setTimeout(() => {
        this.props.form.setFieldsValue(tempObj);
      }, 10);
    }
  };
  handleSubmit = (e) => {
    const { dispatch, form } = this.props;

    e.preventDefault();

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
      }
    });
  };

  async apiRequest(params, columns) {
    return new Promise(async (resolve) => {
      if (!params) {
        params = {}
      }
      let searchParams = new URLSearchParams(this.props.search);
      let studentId = searchParams.get("id");
      params.studentId = studentId

      let response = await Request.loadStudentActivities({ ...params, regExFilters: ["message", "desk"] })
      this.setState({ activityArr: response.data })
      resolve(response)
    })
  }

  showDrawer1 = () => {
    this.setState({
      visible1: true,
    });
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };



  renderFlowDetails = (key) => {
    if (key.details) {
      return (
        <div>
          {" "}
          {key.message}
          <Button
            style={{
              marginLeft: "12px",
              padding: "3px",
              height: "23px",
            }}
            type="primary"
            onClick={() => {
              this.showDrawer();
              this.setState({ smsDetails: key.details });
            }}
          >
            {<Icon type="eye" />}
          </Button>
        </div>
      );
    }

    if (key.message) {
      return <div>{key.message}</div>;
    }
  };

  renderDetails = (key) => {
    if (key.details) {
      return (
        <div>
          {" "}
          {key.message}
          <Button
            style={{
              marginLeft: "12px",
              padding: "3px",
              height: "23px",
            }}
            type="primary"
            onClick={() => {
              this.showDrawer();
              this.setState({ smsDetails: key.details });
            }}
          >
            {<Icon type="eye" />}
          </Button>
        </div>
      );
    }

    if (key.message) {
      return <div>{key.message}</div>;
    }
  };
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  async componentDidMount() {
    this.apiRequest()
    let searchParams = new URLSearchParams(this.props.search);

    let studentId = searchParams.get("id");
    this.setState({ studentId: studentId }, () => {
      // this.table.current.reload()
    });

    // this.apiRequest(studentId);
    let { doc } = await Request.getInquiry(studentId);
    this.setState({ completeInfo: doc });
  }

  render() {
    const { submitting } = this.props;
    const { dispatch } = this.props;
    const { completeInfo } = this.state;

    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
    } = this.props;

    const columns = [
      {
        title: "Detail",
        key: "message",
        dataIndex: "message",
        searchTextName: "message",
        filterRegex: true,
        width: 150,
        render: (u, record) => {
          return this.renderDetails(record);
        },
      },
      {
        title: "Desk",
        key: "desk",
        dataIndex: "desk",
        searchTextName: "desk",
        filterRegex: true,
        width: 150,
        // render: (u, record) => {
        //   return this.renderDetails(record);
        // },
      },
      {
        title: "Done By",
        key: "createdByUser.name",
        dataIndex: "createdByUser.name",
        width: 150,
        render: (val, record) => {
          return (
            <div>{record.createdByUser && record.createdByUser.name} </div>
          );
        },
      },
      {
        title: "Date",
        key: "createdByUser.time",
        dataIndex: "createdByUser.time",
        width: 150,
        render: (val, record) => {
          return (
            <div>
              {record.createdByUser
                ? moment(record.createdByUser.time).format(
                  "DD-MMM-YYYY hh:mm:A"
                )
                : "NA"}
            </div>
          );
        },
      },
    ];

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    };

    const submitFormLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 10, offset: 7 },
        md: { span: 12, offset: 8 },
      },
    };

    return (
      <PageHeaderWrapper title={"Activity"}>
        {completeInfo ? (
          <div style={{ marginBottom: 10 }}>
            <StudentHeader
              info={this.state.studentId}
              data={this.state.completeInfo}
              done={() => { }}
              dispatch={this.props.dispatch}
            />
          </div>
        ) : null}

        {completeInfo ? (
          <Card bordered={true} style={{ marginBottom: 10 }}>
            <StudentInfo info={completeInfo} />
          </Card>
        ) : null}

        {/* <Card bordered={true}>
          <TableComp
            columns={columns}
            id={"desk-activities"}
            showSelector={true}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params)}
            // dataSource={this.state.activityArr}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 50,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
          }}
            bordered
          />
        </Card> */}
        <Card bordered={true}>
          <Steps direction="vertical" size="small" current={0}>

            {/* <Step title={"check"} description={"check"} icon={<Icon type="loading" />}/> */}
            {this.state.activityArr.map((activity, index) => {
              return (
                <Step
                  status="process"
                  title={this.renderFlowDetails(activity)}
                  description={
                    <div>
                      {activity.desk
                        ? `${activity.desk.toLowerCase().includes('desk')
                          ? activity.desk
                          : `${activity.desk} Desk`
                        } | `
                        : ''
                      }

                      {activity.createdByUser
                        ? `Done By:- ${activity.createdByUser.name} | `
                        : ''
                      }

                      {activity.createdByUser
                        ? `Date:- ${moment(activity.createdByUser.time).format(
                          'DD-MMM-YYYY hh:mm A'
                        )}`
                        : ''
                      }
                    </div>
                  }
                  icon={
                    index === 0
                      ? <Icon type="check-circle" theme="twoTone" />
                      : <Icon type="up-circle" theme="twoTone" />
                  }
                />

              )
            })}
            {/* {
            this.state.activityArr.map((activity=>{
              console.log(activity)
              
            }))
          } */}
            {/* {
              _.each(this.state.activityArr, (activity)=>{
                console.log(activity)
                // return (
                //   <Step title={"check"} description={"check"} icon={<Icon type="loading" />}/>
                // )
              })
            } */}
            {/* <Step title="Finished" description="Near to Finish." icon={<Icon type="loading" />}/>
            <Step title={<div>Testing <Button
            style={{
              marginLeft: "12px",
              padding: "3px",
              height: "23px",
            }}
            type="primary"
            onClick={() => {
              this.showDrawer();
              
            }}
          >
            {<Icon type="eye" />}
          </Button></div>} description={<div>Work is Under Process</div>} icon={<Icon type="smile-o" />}/>
            <Step title="Waiting" description="Yet to be Started" icon={<Icon type="smile-o" />}/>
            <Step title="Waiting" description="Yet to be Started" icon={<Icon type="smile-o" />}/> */}
          </Steps>
        </Card>
        {!!this.state.visible && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible: false,
              });
            }}
            visible={this.state.visible}
            width={1000}
          >
            {this.state && this.state.smsDetails && (
              <div>
                <h2
                  style={{
                    marginLeft: "11px",
                    marginTop: "13px",
                    color: "orange",
                  }}
                >
                  Communication Details
                </h2>

                <p
                  style={{
                    padding: "10px",
                    textAlign: "justify",
                    marginLeft: "4px",
                    marginRight: "50px",
                  }}
                >
                  {/*
               {this.state.smsDetails ? S(this.state.smsDetails).stripTags().s : null}
               */}
                  {this.state.smsDetails
                    ? renderHTML(this.state.smsDetails)
                    : null}
                </p>
              </div>
            )}
          </Drawer>
        )}
        {!!this.state.visible1 && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible1: false,
              });
            }}
            visible={this.state.visible1}
            width={1000}
          >
            {this.state && this.state.emailDetails && (
              <div>
                <h2
                  style={{
                    marginLeft: "11px",
                    marginTop: "13px",
                    color: "orange",
                  }}
                >
                  Email Details
                </h2>

                <p
                  style={{
                    padding: "10px",
                    textAlign: "justify",
                    marginLeft: "4px",
                    marginRight: "50px",
                  }}
                >
                  {this.state.emailDetails
                    ? S(this.state.emailDetails).stripTags().s
                    : null}
                </p>
              </div>
            )}
          </Drawer>
        )}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activity);
